export const MESSAGES = {
  HIGH_COST: 'Precio arriba de 200 Bs.',
  DRIVER_ORDER: 'Usuario Repartidor',
  FIRST_ORDER: 'Primer Pedido',
  OTHER: 'Otro'
};
